// Ruta: frontend/src/modules/admin/pages/DashboardPage.tsx
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '@core/hooks/useAuth';
import { useChecklist } from '@core/hooks/useChecklist';

const DashboardPage: React.FC = () => {
  const { user } = useAuth();
  const { checklists, loadChecklists, isLoading } = useChecklist();
  const location = useLocation();

  // ✅ Recarga al volver al dashboard (flecha atrás)
  useEffect(() => {
    loadChecklists();
  }, [location.key]);

  const totalChecklists = checklists.length;
  const totalQuestions = checklists.reduce((acc, c) => acc + (c.questions?.length || 0), 0);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Dashboard</h1>
        <p className="mt-1 text-sm text-gray-600">
          Bienvenido, {user?.email || 'usuario'}
        </p>
      </div>

      {isLoading ? (
        <div className="flex justify-center py-12">
          <div className="text-gray-500">Cargando...</div>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-white rounded-lg shadow p-6">
            <div className="text-sm font-medium text-gray-500">Total Checklists</div>
            <div className="mt-2 text-3xl font-bold text-gray-900">{totalChecklists}</div>
          </div>
          <div className="bg-white rounded-lg shadow p-6">
            <div className="text-sm font-medium text-gray-500">Total Preguntas</div>
            <div className="mt-2 text-3xl font-bold text-gray-900">{totalQuestions}</div>
          </div>
          <div className="bg-white rounded-lg shadow p-6">
            <div className="text-sm font-medium text-gray-500">Rol</div>
            <div className="mt-2 text-3xl font-bold text-gray-900">{user?.role || '-'}</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DashboardPage;